import e from "@dialpad/dialtone-tokens/layered/themes/tokens-118-colors.css?inline";
//#region themes/118.js
var t = { brand: {
	css: e,
	name: "118"
} };
//#endregion
export { t as default };
